export const Email = (props) => {
    const { email, setEmail } = props;
    return (
        <div className="row">
            <label className="label" htmlFor="email">Email</label>
            <input type="email" name="email" id="email" defaultValue={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
    )
}